


























import _ from 'lodash'
import A from '@/utilities/alpha'
import { Icon } from '@alpha/ink'
import ExistingAssetPicker from './ExistingAssetPicker.vue'
import ImagePicker from './ImagePicker.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'

@Component({
  components: {
    Icon,
    ExistingAssetPicker,
    ImagePicker
  }
})
export default class ConceptAssetImage extends Vue {
  @Prop({ required: true }) readonly imageAsset!: Record<string, db.Prototype>
  @Prop({ default: false }) readonly editable!: boolean
  @Prop({ default: () => ({}) }) readonly sharedImages!: Record<string, db.Prototype>

  get assetValue (): Partial<db.Prototype> {
    var keys = Object.keys(this.imageAsset)
    if (keys.length === 0) { return {} }
    return this.imageAsset[keys[0]]
  }

  get selectableImages () {
    return _.pickBy(this.sharedImages, (sharedImage, ts) => {
      return sharedImage.url !== this.assetValue.url
    })
  }

  updateAssetField (field: keyof db.Prototype, value: any) {
    var newAsset = A.clone(this.imageAsset)
    var key = Object.keys(newAsset)[0];
    (newAsset[key][field] as any) = value
    this.$emit('update', newAsset)
  }

  removeImage () {
    this.$emit('update', {})
  }

  addImage (image: db.Prototype) {
    var key = new Date().getTime()
    var asset: Record<string, db.Prototype> = {}
    asset[key] = image
    this.$emit('update', asset)
  }

  selectExistingAsset (asset: db.Prototype, ts: number) {
    var newAsset: Record<string, db.Prototype> = {}
    newAsset[ts] = A.clone(asset)
    this.$emit('update', newAsset)
  }
}
